export const FilledCheck = ({ className = '' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_660_3126)">
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M7.7998 12.6L10.1998 15L16.1998 8.99998"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_660_3126">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
